import React from 'react';
import Field from './Field';
import hasParentWithClassName from '../../../hasParentWithClassName';
import WarningsContainer from '../../common/WarningsContainer';
import InformationsContainer from '../../common/InformationsContainer';

class FieldSelectBodyPortal extends React.Component {
    constructor(props) {
        super(props)

        this.el = document.getElementById('field-select-body-portal')

        if (this.el === null) {
            this.el = document.createElement('div')
            this.el.setAttribute('id', 'field-select-body-portal')
            document.body.appendChild(this.el)
        }
    }

    componentDidMount() {
        let rect = this.props.rootRef.current.getBoundingClientRect()
        let height = this.props.buttonRef.current.offsetHeight

        this.el.style.position = 'absolute';
        this.el.style.width = rect.width + 'px';
        this.el.style.top = Math.floor(rect.top + window.pageYOffset + height - 1) + 'px';
        this.el.style.left = rect.left + 'px';
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        )
    }
}

export default class FieldSelect extends Field {

    static currentlyOpenSelect = null

    constructor(props) {
        super(props)

        this.rootRef = React.createRef()
        this.buttonRef = React.createRef()
        this.state = {
            open: false,
            selectedOption: props.value,
            items: this.removeDuplicated(props.items, (x, y) => x.value === y.value),
            playingExitAnimation: false
        }
    }

    componentDidUpdate() {
        if (this.state.open) {
            setTimeout(() => {
                window.addEventListener('click', this.onWindowClick)
            }, 200)
        } else {
            window.removeEventListener('click', this.onWindowClick);
        }
    }

    onWindowClick = e => {
        if (this.state.open === false) {
            return
        }

        if (e.target.className && e.target.className.includes('dropdown-item--disabled')) {
            return;
        }

        var isDropdown = el => hasParentWithClassName(el, 'dropdown') === true
        var canHide = false
        if (e.target.tagName === 'path')
            canHide = !isDropdown(e.target.ownerSVGElement.parentElement)
        else
            canHide = !isDropdown(e.target.parentElement)

        if (canHide) {
            this.hide()
            FieldSelect.currentlyOpenSelect = null
        }
    }

    removeDuplicated(input, cmp) {
        let out = []

        input.forEach(x => {
            let wouldDuplicate = false

            out.forEach(y => {
                wouldDuplicate = cmp(x, y)
            })

            if (!wouldDuplicate) {
                out.push(x)
            }
        })

        return out
    }

    componentWillUnmount() {
        if (FieldSelect.currentlyOpenSelect === this) {
            FieldSelect.currentlyOpenSelect = null
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            open: false,
            selectedOption: nextProps.value,
            items: this.removeDuplicated(nextProps.items, (x, y) => x.value === y.value)
        })
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextState.selectedOption !== this.state.selectedOption ||
            nextState.items !== this.state.items ||
            nextState.open !== this.state.open ||
            nextProps.disabled !== this.props.disabled
        )
    }

    onButtonClick = e => {
        if (this.isDisabled() || this.isReadOnly()) {
            return
        }

        if (FieldSelect.currentlyOpenSelect !== null && FieldSelect.currentlyOpenSelect !== this) {
            FieldSelect.currentlyOpenSelect.hide()
            FieldSelect.currentlyOpenSelect = null
        }

        if (this.state.open === false) {
            FieldSelect.currentlyOpenSelect = this
        } else {
            FieldSelect.currentlyOpenSelect = null
        }

        if (this.state.open) {
            this.hide()
        } else {
            this.show()
        }
    }

    onItemClick = item => {
        this.setState({
            selectedOption: item.value,
            open: false
        })

        if (this.props.onChange) {
            this.props.onChange(item.value)
        }
    }

    show() {
        this.setState({open: true})
    }

    hide() {
        this.setState({open: false})
    }

    renderField() {
        const currentItem = this.state.items.find(x => x.value === this.state.selectedOption)
        const rootClassNames = ['dropdown', 'dropdown--react', 'w-100']

        if (this.isDisabled()) {
            rootClassNames.push('dropdown--disabled')
        } else {
            if (this.state.open) {
                rootClassNames.push('dropdown--open')
            }

            if (this.state.playingExitAnimation) {
                rootClassNames.push('dropdown--exit')
            }
        }

        if (this.isReadOnly()) {
            rootClassNames.push('dropdown--read-only')
        }
        if (this.props.className) {
            rootClassNames.push(this.props.className);
        }

        const getCurrentItem = () => currentItem ? currentItem.text : '';

        return (
            <div className={rootClassNames.join(' ')} ref={this.rootRef}>
                <div className="dropdown-button" onClick={this.onButtonClick} ref={this.buttonRef}>
                    <div className="dropdown-button-body" title={getCurrentItem()}>
                        {getCurrentItem()}
                    </div>

                    <svg width="12" height="12" viewBox="0 0 12 12">
                        <g fill="none" fillRule="evenodd">
                            <path fillRule="nonzero" d="M0 0h12v12H0z"/>
                            <path fill="#9da4b3"
                                  d="M11.606 3.599l-.386-.389a.64.64 0 0 0-.457-.188.641.641 0 0 0-.456.188L5.9 7.617 1.488 3.205a.64.64 0 0 0-.457-.188.64.64 0 0 0-.456.188l-.386.387a.646.646 0 0 0 0 .912l5.253 5.272a.66.66 0 0 0 .457.207h.002a.66.66 0 0 0 .457-.207l5.248-5.258a.652.652 0 0 0 0-.919z"/>
                        </g>
                    </svg>
                </div>
                {this.state.open ? (
                    this.props.forceNonPortal ? (
                        <div className="dropdown-body" style={{display: 'block'}}>
                            {this.state.items.map(this.renderItem)}
                        </div>
                    ) : (
                        <FieldSelectBodyPortal rootRef={this.rootRef} buttonRef={this.buttonRef}>
                            <div className={`dropdown-body ${this.props.className || ''}`} style={{display: 'block'}}>
                                {this.state.items.map(this.renderItem)}
                            </div>
                        </FieldSelectBodyPortal>
                    )
                ) : ''}

                {this.props.warning && (
                    <React.Fragment>
                        <span className="input-number-overlay"></span>
                        <span className="input-warning-tooltip">
                            <WarningsContainer warning={this.props.warning}/>
                        </span>
                    </React.Fragment>
                )}

                {this.props.information && (
                    <React.Fragment>
                        <span className="input-number-overlay"></span>
                        <span className="input-information-tooltip">
                            <InformationsContainer information={this.props.information}/>
                        </span>
                    </React.Fragment>
                )}
            </div>
        )
    }

    renderItem = (item, idx) => {
        const classNames = ['dropdown-item']
        if (item.value === this.state.selectedOption) {
            classNames.push('dropdown-item--selected')
        }
        if (item.disabled == true) {
            classNames.push('dropdown-item--disabled')
        }

        var onClick = () => {
            if (item.disabled !== true) {
                this.onItemClick(item);
            }
        }

        return (
            <div key={item.value} className={classNames.join(' ')} onClick={onClick}
                 style={{animationDelay: (idx * 30) + 'ms'}}>
                {item.text}
            </div>
        )
    }

    isDisabled() {
        return this.props.disabled || this.state.items.length === 0
    }

    isReadOnly() {
        return !this.props.forceReadable && (this.props.readonly || this.state.items.length === 1)
    }
}